export default "__VITE_ASSET__CRVKz2Qg__"